module.exports = __webpack_public_path__ + "img/uz.ef2cba68.svg";